/**
 * Created by mathias.gamperl on 03.02.2015.
 */

export default ["$scope", "$uibModalInstance", "AuthenticationService", "$timeout", "SessionExpirationService","moment", function SessionExpirationDialogController($scope, $uibModalInstance, AuthenticationService, $timeout, SessionExpirationService,moment) {


  function updateDialog() {
    $scope.secondsUntilExpire--;

    if ($scope.secondsUntilExpire <= 0) {
      $uibModalInstance.close();
    }
    $timeout(updateDialog, 1000);
  }


  SessionExpirationService.getSesionInformation().then(function (result) {
    $scope.expireAt = moment(result.timeout).calendar();
    $scope.secondsUntilExpire = result.secondsToTimeout;

    $timeout(updateDialog, 1000);
  });


  $scope.extendSession = function () {
    $uibModalInstance.close();
  };
}];



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/sessionExpiration/SessionExpirationDialogController.js